export default (store, router, emitter) => {
  return (error) => {
    if (error.response.status === 401) {
      if(store.state.auth.user) {
        emitter.emit('toast', {severity: 'warn', message: 'warning.sessionended'})
      }
      store.dispatch('auth/logout')
        .then(() => router.push({name: 'login'}))
        .catch(console.error)
    }
    return Promise.reject(error)
  }
}
